import { render, staticRenderFns } from "./addNewContract.vue?vue&type=template&id=6d53d673&scoped=true"
import script from "./addNewContract.vue?vue&type=script&lang=js"
export * from "./addNewContract.vue?vue&type=script&lang=js"
import style0 from "./addNewContract.vue?vue&type=style&index=0&id=6d53d673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53d673",
  null
  
)

export default component.exports